module.exports = __webpack_public_path__ + "assets/magnify-creme.svg";